"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var SiftModalLayout = function SiftModalLayout(_ref) {
  var aside = _ref.aside,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full justify-between bg-app"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-screen overflow-auto py-20 flex flex-grow z-10",
    style: {
      shadow: 'rgba(0, 0, 0, 0.035) 0px 0px 20px, rgba(0, 0, 0, 0.035) 0px 0px 20px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-auto",
    style: {
      width: 768
    }
  }, children)), aside);
};
var _default = exports["default"] = SiftModalLayout;
//# sourceMappingURL=ModalLayout.js.map